import { keepPreviousData } from "@tanstack/react-query";
import { debounce } from "lodash";
import { useState } from "react";
import { useGetListExtension } from "service/query/extension.query";

const DEFAULT_SIZE = 20;

export const useSelectExtension = () => {
  const [limit, setLimit] = useState(DEFAULT_SIZE);
  const [where, setWhere] = useState();

  const { data: listExtension, isFetching } = useGetListExtension(
    {
      filter: { order: "createdAt DESC", limit, where },
    },
    { placeholderData: keepPreviousData }
  );

  const handleSearch = debounce((text) => {
    let searchWhere;
    if (text) {
      if (text.includes("-")) {
        const name = text.split("-")[0].trim();
        const username = text.split("-")[1]?.trim() || "";
        searchWhere = {
          or: [{ name: { like: name } }, { username: { like: username } }],
        };
      } else {
        searchWhere = {
          or: [
            { name: { like: text.trim() } },
            { username: { like: text.trim() } },
          ],
        };
      }
    }
    setWhere(searchWhere);
    setLimit(DEFAULT_SIZE);
  }, 300);

  const handleScroll = (e) => {
    const isBottom =
      Math.ceil(e.target.scrollTop) + e.target.clientHeight >=
      e.target.scrollHeight;
    if (isBottom && !isFetching) {
      setLimit((limit) => limit + DEFAULT_SIZE);
    }
  };

  const extensionOptions = listExtension?.map((item) => ({
    value: item.id,
    label: `${item.name} - ${item.username}`,
  }));

  return {
    options: extensionOptions,
    loading: isFetching,
    handleScroll,
    handleSearch,
  };
};
